import {
  getCurrentCustomerId,
  getCurrentWorkflowId,
  generateSitesRoute,
} from "../../../redux/modules/route/routes";
import { pushRoute } from "../../../redux/modules/route/actions";
import { AppDispatch, AppGetState } from "../../../store";
import { getRouterState } from "../../../redux/modules/rootReducer";
import { fetchCustomerLevelWorkflow } from "../../../redux/modules/workflow/actions";
import { performWorkflowActions } from "../../../redux/modules/workflow/actions";
import { getWorkflowStateById } from "../../../redux/modules/workflow/reducer";

import {
  IWorkflowAction,
  IWorkflowStep,
} from "../../../redux/modules/currentWorkflow/reducer";

export const userOpensWorkflowViewPage = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
) => {
  await dispatch(userOpensWorkflowViewPageOldStyle());
};

export const userOpensWorkflowViewPageOldStyle = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
) => {
  const routeState = getRouterState(getState());
  const currentWorkflowId = getCurrentWorkflowId(routeState);
  return dispatch(fetchCustomerLevelWorkflow(currentWorkflowId));
};

export const userSubmitsWorkflowStep = (
  customerId: string,
  step: IWorkflowStep,
  actions: IWorkflowAction[],
) => async (dispatch: AppDispatch, getState: AppGetState): Promise<void> => {
  const routeState = getRouterState(getState());
  const currentCustomerId = getCurrentCustomerId(routeState);
  const currentWorkflowId = getCurrentWorkflowId(routeState);
  const workflowsState = getState().workflows;
  const workflowState = getWorkflowStateById(workflowsState, currentWorkflowId)
    .entry;
  await dispatch(
    performWorkflowActions(
      workflowState.id,
      workflowState.workflowType,
      step,
      actions,
      currentCustomerId,
      null,
    ),
  );
};

export const userClicksBackButton = () => async (
  dispatch: AppDispatch,
  getState: AppGetState,
) => {
  const route = getRouterState(getState());
  const customerId: string = getCurrentCustomerId(route);
  dispatch(pushRoute(generateSitesRoute(customerId)));
};
